<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2022-01-15 20:49:36
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-10 17:50:27
-->
<template>
  <div class="content">
    <el-table :data="list" style="width: 100%">
      <el-table-column
        prop="personName"
        label="成员姓名"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="relationName"
        label="与户主关系"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column label="性别" min-width="10%" align="center">
        <template slot-scope="scope">
          {{ scope.row.sex | formatSex }}
        </template>
      </el-table-column>
      <el-table-column
        prop="personAge"
        label="年龄"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号"
        min-width="10%"
        align="center"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  filters: {
    formatSex(value) {
      let result = "";
      switch (value) {
        case 1:
          result = "男";
          break;
        case 0:
          result = "女";
          break;
      }
      return result;
    },
  },
  props: {
    list: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped></style>
